// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Light theme — приглушённый, чтобы не слепить глаз. Не stark white. */
  --bg: #e4e6eb;            /* dim cool grey, заметно темнее белого */
  --bg-card: #eef0f4;       /* off-white карточка */
  --bg-subtle: #e8eaf0;
  --bg-hover: #dadde3;
  --border: #c9cdd4;
  --border-strong: #b3b8c1;
  --text: #2a2d33;          /* тёмный графит, не чёрный */
  --text-muted: #5a6068;
  --text-faint: #888d96;
  --accent: #5b5bd6;
  --accent-hover: #4747b8;
  --accent-soft: #dfe1f1;
  --detail-bg: #e9ebf0;
  --detail-header-bg: #dde1ea;
  --detail-group-bg: #e3e6ed;
  --detail-positive-bg: #d9e9d9;
  --detail-positive-text: #1f5f30;
  --detail-negative-bg: #ebd8d6;
  --detail-negative-text: #8a2a23;
  --warning-bg: #ecdfb8;
  --warning-border: #c08820;
  --warning-text: #735008;
  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);
  --shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.05);
  --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.05);
  --radius: 10px;
  --radius-sm: 6px;
}

[data-theme="dark"] {
  --bg: #0f1115;
  --bg-card: #161a21;
  --bg-subtle: #1a1f27;
  --bg-hover: #20262f;
  --border: #252b35;
  --border-strong: #323945;
  --text: #e4e6eb;
  --text-muted: #9ba3af;
  --text-faint: #6b7280;
  --accent: #8b8bf0;
  --accent-hover: #a3a3f5;
  --accent-soft: #1f2038;
  --detail-bg: #181c24;
  --detail-header-bg: #1a1f27;
  --detail-group-bg: #1a1f27;
  --detail-positive-bg: #0f2018;
  --detail-positive-text: #4ade80;
  --detail-negative-bg: #211014;
  --detail-negative-text: #f87171;
  --warning-bg: #2a2008;
  --warning-border: #b45309;
  --warning-text: #fbbf24;
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3);
}

body {
  background: var(--bg);
  color: var(--text);
  margin: 0;
}

.App {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  min-height: 100vh;
  display: flex;
}

/* Sidebar */
.App-sidebar {
  width: 220px;
  background: var(--bg-card);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  padding: 1.25rem 0.75rem;
  position: sticky;
  top: 0;
  height: 100vh;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0 0.5rem 1.25rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid var(--border);
}

.brand-logo {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.95rem;
}

.brand-name {
  font-weight: 700;
  font-size: 1.05rem;
  letter-spacing: -0.01em;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding-top: 0.75rem;
  flex: 1 1;
}

.sidebar-nav a {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 0.75rem;
  text-decoration: none;
  color: var(--text-muted);
  font-weight: 500;
  font-size: 0.9rem;
  border-radius: var(--radius-sm);
  transition: all 0.12s;
}

.sidebar-nav a:hover {
  background: var(--bg);
  color: var(--text);
}

.sidebar-nav a.active {
  background: var(--accent-soft);
  color: var(--accent);
}

.nav-icon {
  font-size: 0.8rem;
  width: 16px;
  text-align: center;
  opacity: 0.7;
}

.sidebar-nav a.active .nav-icon {
  opacity: 1;
}

.sidebar-footer {
  border-top: 1px solid var(--border);
  padding-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.theme-toggle {
  width: 100%;
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0.4rem 0.75rem;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.12s;
}

.theme-toggle:hover {
  border-color: var(--accent);
  color: var(--accent);
}

/* Main content area */
.App-main {
  flex: 1 1;
  overflow-y: auto;
  height: 100vh;
}

.App-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 2.5rem;
}

.App-content:has(.report-wide) {
  max-width: none;
}

.upload-section {
  margin-bottom: 1.5rem;
}

.file-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.file-label {
  font-weight: 600;
  min-width: 50px;
}

.file-name {
  color: #16a34a;
  font-size: 0.875rem;
}

.file-name.file-new {
  color: var(--accent);
}

.file-replace {
  padding: 0.2rem 0.5rem;
  border: 1px solid var(--border-strong);
  border-radius: 4px;
  background: var(--bg-card);
  cursor: pointer;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.file-replace:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.actions button {
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: var(--accent);
  color: white;
}

.actions button:disabled {
  background: #b8b8e5;
  cursor: not-allowed;
}

.actions button:hover:not(:disabled) {
  background: var(--accent-hover);
}

.status {
  padding: 0.75rem 1rem;
  background: var(--bg-subtle);
  border-radius: 6px;
  color: var(--text);
}

/* Cluster list (Upload page) */
.cluster-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.cluster-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 2px solid var(--border-strong);
  border-radius: 8px;
  cursor: pointer;
  background: var(--bg-card);
  transition: border-color 0.15s;
}

.cluster-item:hover {
  border-color: #b8b8e5;
}

.cluster-item.cluster-active {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.cluster-name {
  font-weight: 500;
}

/* Default checkbox in cluster/config items */
.default-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--accent);
  flex-shrink: 0;
}

.cluster-delete {
  background: none;
  border: none;
  color: var(--text-faint);
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;
  padding: 0 0.25rem;
}

.cluster-delete:hover {
  color: #ef4444;
}

.cluster-add {
  padding: 0.5rem 1rem;
  border: 2px dashed var(--border-strong);
  border-radius: 8px;
  background: none;
  cursor: pointer;
  color: var(--text-muted);
  font-weight: 500;
}

.cluster-add:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.cluster-new {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.cluster-new input {
  padding: 0.4rem 0.75rem;
  border: 2px solid var(--border-strong);
  border-radius: 6px;
  font-size: 0.875rem;
}

.cluster-new button {
  padding: 0.4rem 0.75rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  background: var(--accent);
  color: white;
}

.cluster-new button:last-child {
  background: var(--border);
  color: var(--text);
}

/* Cluster selector (Home page) */
.cluster-selector {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}

.cluster-selector label {
  font-weight: 500;
  color: var(--text-muted);
  font-size: 0.875rem;
}

.cluster-selector select {
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  background: var(--bg-card);
  color: var(--text);
  cursor: pointer;
}

.cluster-selector select:focus {
  outline: none;
  border-color: var(--accent);
}

.loading-indicator {
  color: var(--text-muted);
  font-size: 0.875rem;
}

/* Auth gate */
.auth-gate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.auth-gate h2 {
  margin-bottom: 1.5rem;
  font-size: 1.25rem;
}

.auth-form {
  display: flex;
  gap: 0.5rem;
}

.auth-form input {
  padding: 0.5rem 0.75rem;
  border: 2px solid var(--border-strong);
  border-radius: 6px;
  font-size: 1rem;
  width: 250px;
}

.auth-form button {
  padding: 0.5rem 1.25rem;
  border: none;
  border-radius: 6px;
  background: var(--accent);
  color: white;
  font-size: 1rem;
  cursor: pointer;
}

.auth-form button:hover {
  background: var(--accent-hover);
}

.logout-btn {
  width: 100%;
  background: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 0.4rem 0.75rem;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.12s;
}

.logout-btn:hover {
  border-color: #ef4444;
  color: #ef4444;
}

/* Salary page */
.salary-hint {
  color: var(--text-faint);
  margin-bottom: 1rem;
}

.salary-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 480px;
  margin-bottom: 1rem;
}

.salary-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border-strong);
  border-radius: 6px;
  background: var(--bg-card);
}

.salary-config {
  flex: 1 1;
  font-weight: 500;
}

.salary-row input {
  width: 200px;
  padding: 0.4rem 0.6rem;
  border: 1px solid var(--border-strong);
  border-radius: 4px;
  background: var(--bg);
  color: var(--text);
  font-family: inherit;
}

.salary-totals {
  display: flex;
  gap: 2rem;
  max-width: 480px;
  margin: 0.5rem 0 1rem;
  padding: 0.75rem;
  border-top: 1px solid var(--border-strong);
  font-weight: 500;
}

.salary-totals-label {
  color: var(--text-faint);
  font-weight: 400;
  margin-right: 0.4rem;
}

.salary-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.salary-actions button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  background: var(--accent);
  color: white;
  cursor: pointer;
  font-weight: 500;
}

.salary-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.salary-status {
  color: var(--text-faint);
}

/* ==========================================================================
   Upload page (v1). Own \`up-\` classes: the older .cluster-* / .file-row classes are shared with
   Groups, Home, Overall and the v2 pages, so they are left untouched here.
   ========================================================================== */

.up-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.up-header h2 {
  margin: 0;
}

.up-toolbar {
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
  flex-wrap: wrap;
}

.up-search,
.up-select {
  padding: 0.45rem 0.7rem;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background: var(--bg-card);
  color: var(--text);
  font: inherit;
  font-size: 0.875rem;
}

.up-search {
  min-width: 220px;
}

.up-search:focus,
.up-select:focus {
  outline: none;
  border-color: var(--accent);
}

/* Cluster list on the left, file panel on the right; stacked on narrow screens. */
.up-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 400px;
  gap: 1.25rem;
  align-items: start;
  margin-bottom: 2.5rem;
}

@media (max-width: 960px) {
  .up-layout {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Groups stack vertically at full width. The old .cluster-list is a wrapping flex row, which laid
   the group sections side by side and made neighbours jump when one was expanded. */
.up-browser {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.up-section {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--bg-card);
  overflow: hidden;
}

.up-section-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: 0;
  background: var(--bg-subtle);
  color: var(--text);
  font: inherit;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.up-section-head:hover {
  background: var(--bg-hover);
}

.up-section-arrow {
  width: 1em;
  font-size: 0.75rem;
  color: var(--text-muted);
}

.up-section-swatch {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.up-section-count {
  margin-left: auto;
  font-size: 0.75rem;
  color: var(--text-faint);
}

.up-section-body {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0.6rem;
  border-top: 1px solid var(--border);
}

.up-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 100%;
  padding: 0.3rem 0.45rem 0.3rem 0.5rem;
  border: 1.5px solid var(--border-strong);
  border-radius: 999px;
  background: var(--bg-card);
  font-size: 0.85rem;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s;
}

.up-chip:hover {
  border-color: var(--accent);
}

.up-chip:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}

.up-chip.is-active {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.up-chip-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}

.up-chip-default,
.up-chip-delete {
  padding: 0 0.1rem;
  border: 0;
  background: none;
  line-height: 1;
  cursor: pointer;
  color: var(--text-faint);
}

.up-chip-default {
  font-size: 0.95rem;
}

.up-chip-default.is-on {
  color: #e0a800;
}

/* Delete only shows on hover/focus, so a stray click on a chip cannot land on it. */
.up-chip-delete {
  font-size: 1.1rem;
  opacity: 0;
  transition: opacity 0.12s;
}

.up-chip:hover .up-chip-delete,
.up-chip:focus-within .up-chip-delete {
  opacity: 1;
}

.up-chip-delete:hover {
  color: #ef4444;
}

@media (hover: none) {
  .up-chip-delete {
    opacity: 1;
  }
}

.up-badge {
  padding: 1px 6px;
  border-radius: 10px;
  background: var(--text-faint);
  color: #fff;
  font-size: 0.68rem;
  white-space: nowrap;
}

.up-add {
  padding: 0.55rem 1rem;
  border: 1.5px dashed var(--border-strong);
  border-radius: var(--radius-sm);
  background: none;
  color: var(--text-muted);
  font: inherit;
  font-weight: 500;
  cursor: pointer;
}

.up-add:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.up-new {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.up-new .up-search {
  flex: 1 1;
}

.up-empty {
  padding: 1.25rem;
  border: 1px dashed var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  text-align: center;
}

/* File panel: stays in view while a long cluster list scrolls (.App-main is the scroll box). */
.up-panel {
  position: sticky;
  top: 1rem;
  padding: 1rem 1.1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
  box-shadow: var(--shadow-sm);
  scroll-margin-top: 1rem;
}

@media (max-width: 960px) {
  .up-panel {
    position: static;
  }
}

.up-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.up-panel-heading {
  min-width: 0;
}

.up-panel-eyebrow {
  color: var(--text-faint);
  font-size: 0.7rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.up-panel-title {
  margin: 0.1rem 0 0;
  font-size: 1.1rem;
  overflow-wrap: anywhere;
}

.up-ready {
  padding: 2px 9px;
  border-radius: 10px;
  background: var(--warning-bg);
  color: var(--warning-text);
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.up-ready.is-ready {
  background: rgba(22, 163, 74, 0.15);
  color: #16a34a;
}

.up-panel-empty {
  padding: 2rem 0.5rem;
  color: var(--text-muted);
  text-align: center;
}

.up-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.55rem 0;
  border-bottom: 1px solid var(--border);
}

.up-file-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.up-file-label {
  font-size: 0.85rem;
  font-weight: 600;
}

.up-file-name {
  overflow: hidden;
  color: var(--text-faint);
  font-size: 0.78rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.up-file.is-present .up-file-name {
  color: #16a34a;
}

.up-file.is-pending .up-file-name {
  color: var(--accent);
}

.up-file .file-replace {
  flex-shrink: 0;
}

.up-optional-toggle {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  width: 100%;
  padding: 0.8rem 0 0.3rem;
  border: 0;
  background: none;
  color: var(--text-muted);
  font: inherit;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}

.up-optional-count {
  margin-left: auto;
  color: var(--text-faint);
  font-size: 0.75rem;
}

.up-panel .actions {
  margin-bottom: 0.5rem;
}

/* Settings that are not about a cluster, kept out of the file workflow. */
.up-settings h2 {
  margin: 0 0 0.75rem;
}

.up-settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.up-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-card);
}

.up-card h4 {
  margin: 0 0 0.2rem;
}

.up-card-hint {
  margin: 0 0 0.75rem;
  color: var(--text-faint);
  font-size: 0.78rem;
}

.up-config-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.up-config {
  padding: 0.3rem 0.75rem;
  border: 1.5px solid var(--border-strong);
  border-radius: 999px;
  background: var(--bg-card);
  color: var(--text);
  font: inherit;
  font-size: 0.85rem;
  cursor: pointer;
}

.up-config:hover {
  border-color: var(--accent);
}

.up-config.is-on {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 600;
}

.up-inline {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  min-width: 0;
}

.up-inline input[type="file"] {
  max-width: 100%;
}

.up-ellipsis {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.up-rate {
  width: 130px;
  min-width: 0;
}

.up-primary {
  padding: 0.25rem 0.8rem;
  border: none;
  border-radius: 4px;
  background: var(--accent);
  color: white;
  cursor: pointer;
}

.up-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Salary page: the multiplier comes from the shared period setting, so say where it is from. */
.salary-months-hint {
  display: block;
  margin-top: 0.15rem;
  color: var(--text-faint);
  font-size: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uEAAuE;EACvE,aAAa,aAAa,yCAAyC;EACnE,kBAAkB,QAAQ,uBAAuB;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe,WAAW,6BAA6B;EACvD,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,6CAA6C;EAC7C,4EAA4E;EAC5E,gFAAgF;EAChF,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,yCAAyC;EACzC,oEAAoE;EACpE,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,8EAA8E;EAC9E,iBAAiB;EACjB,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;+EAG+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;oFACoF;AACpF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,wCAAwC;EACxC,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,oFAAoF;AACpF;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,+FAA+F;AAC/F;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+FAA+F;AAC/F;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB","sourcesContent":[":root {\n  /* Light theme — приглушённый, чтобы не слепить глаз. Не stark white. */\n  --bg: #e4e6eb;            /* dim cool grey, заметно темнее белого */\n  --bg-card: #eef0f4;       /* off-white карточка */\n  --bg-subtle: #e8eaf0;\n  --bg-hover: #dadde3;\n  --border: #c9cdd4;\n  --border-strong: #b3b8c1;\n  --text: #2a2d33;          /* тёмный графит, не чёрный */\n  --text-muted: #5a6068;\n  --text-faint: #888d96;\n  --accent: #5b5bd6;\n  --accent-hover: #4747b8;\n  --accent-soft: #dfe1f1;\n  --detail-bg: #e9ebf0;\n  --detail-header-bg: #dde1ea;\n  --detail-group-bg: #e3e6ed;\n  --detail-positive-bg: #d9e9d9;\n  --detail-positive-text: #1f5f30;\n  --detail-negative-bg: #ebd8d6;\n  --detail-negative-text: #8a2a23;\n  --warning-bg: #ecdfb8;\n  --warning-border: #c08820;\n  --warning-text: #735008;\n  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);\n  --shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.05);\n  --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.05);\n  --radius: 10px;\n  --radius-sm: 6px;\n}\n\n[data-theme=\"dark\"] {\n  --bg: #0f1115;\n  --bg-card: #161a21;\n  --bg-subtle: #1a1f27;\n  --bg-hover: #20262f;\n  --border: #252b35;\n  --border-strong: #323945;\n  --text: #e4e6eb;\n  --text-muted: #9ba3af;\n  --text-faint: #6b7280;\n  --accent: #8b8bf0;\n  --accent-hover: #a3a3f5;\n  --accent-soft: #1f2038;\n  --detail-bg: #181c24;\n  --detail-header-bg: #1a1f27;\n  --detail-group-bg: #1a1f27;\n  --detail-positive-bg: #0f2018;\n  --detail-positive-text: #4ade80;\n  --detail-negative-bg: #211014;\n  --detail-negative-text: #f87171;\n  --warning-bg: #2a2008;\n  --warning-border: #b45309;\n  --warning-text: #fbbf24;\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow: 0 1px 3px rgba(0, 0, 0, 0.4), 0 1px 2px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\nbody {\n  background: var(--bg);\n  color: var(--text);\n  margin: 0;\n}\n\n.App {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  min-height: 100vh;\n  display: flex;\n}\n\n/* Sidebar */\n.App-sidebar {\n  width: 220px;\n  background: var(--bg-card);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  padding: 1.25rem 0.75rem;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n}\n\n.sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0 0.5rem 1.25rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.brand-logo {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: var(--accent);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.brand-name {\n  font-weight: 700;\n  font-size: 1.05rem;\n  letter-spacing: -0.01em;\n}\n\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  padding-top: 0.75rem;\n  flex: 1;\n}\n\n.sidebar-nav a {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.5rem 0.75rem;\n  text-decoration: none;\n  color: var(--text-muted);\n  font-weight: 500;\n  font-size: 0.9rem;\n  border-radius: var(--radius-sm);\n  transition: all 0.12s;\n}\n\n.sidebar-nav a:hover {\n  background: var(--bg);\n  color: var(--text);\n}\n\n.sidebar-nav a.active {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n\n.nav-icon {\n  font-size: 0.8rem;\n  width: 16px;\n  text-align: center;\n  opacity: 0.7;\n}\n\n.sidebar-nav a.active .nav-icon {\n  opacity: 1;\n}\n\n.sidebar-footer {\n  border-top: 1px solid var(--border);\n  padding-top: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.theme-toggle {\n  width: 100%;\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 0.4rem 0.75rem;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.12s;\n}\n\n.theme-toggle:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Main content area */\n.App-main {\n  flex: 1;\n  overflow-y: auto;\n  height: 100vh;\n}\n\n.App-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem 2.5rem;\n}\n\n.App-content:has(.report-wide) {\n  max-width: none;\n}\n\n.upload-section {\n  margin-bottom: 1.5rem;\n}\n\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.file-label {\n  font-weight: 600;\n  min-width: 50px;\n}\n\n.file-name {\n  color: #16a34a;\n  font-size: 0.875rem;\n}\n\n.file-name.file-new {\n  color: var(--accent);\n}\n\n.file-replace {\n  padding: 0.2rem 0.5rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 4px;\n  background: var(--bg-card);\n  cursor: pointer;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.file-replace:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.actions button {\n  padding: 0.5rem 1.25rem;\n  font-size: 1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  background: var(--accent);\n  color: white;\n}\n\n.actions button:disabled {\n  background: #b8b8e5;\n  cursor: not-allowed;\n}\n\n.actions button:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.status {\n  padding: 0.75rem 1rem;\n  background: var(--bg-subtle);\n  border-radius: 6px;\n  color: var(--text);\n}\n\n/* Cluster list (Upload page) */\n.cluster-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.cluster-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: 2px solid var(--border-strong);\n  border-radius: 8px;\n  cursor: pointer;\n  background: var(--bg-card);\n  transition: border-color 0.15s;\n}\n\n.cluster-item:hover {\n  border-color: #b8b8e5;\n}\n\n.cluster-item.cluster-active {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.cluster-name {\n  font-weight: 500;\n}\n\n/* Default checkbox in cluster/config items */\n.default-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--accent);\n  flex-shrink: 0;\n}\n\n.cluster-delete {\n  background: none;\n  border: none;\n  color: var(--text-faint);\n  cursor: pointer;\n  font-size: 1.25rem;\n  line-height: 1;\n  padding: 0 0.25rem;\n}\n\n.cluster-delete:hover {\n  color: #ef4444;\n}\n\n.cluster-add {\n  padding: 0.5rem 1rem;\n  border: 2px dashed var(--border-strong);\n  border-radius: 8px;\n  background: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.cluster-add:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.cluster-new {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cluster-new input {\n  padding: 0.4rem 0.75rem;\n  border: 2px solid var(--border-strong);\n  border-radius: 6px;\n  font-size: 0.875rem;\n}\n\n.cluster-new button {\n  padding: 0.4rem 0.75rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  background: var(--accent);\n  color: white;\n}\n\n.cluster-new button:last-child {\n  background: var(--border);\n  color: var(--text);\n}\n\n/* Cluster selector (Home page) */\n.cluster-selector {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  padding: 0.75rem 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n\n.cluster-selector label {\n  font-weight: 500;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n.cluster-selector select {\n  padding: 0.35rem 0.6rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.9rem;\n  background: var(--bg-card);\n  color: var(--text);\n  cursor: pointer;\n}\n\n.cluster-selector select:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.loading-indicator {\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n/* Auth gate */\n.auth-gate {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n}\n\n.auth-gate h2 {\n  margin-bottom: 1.5rem;\n  font-size: 1.25rem;\n}\n\n.auth-form {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.auth-form input {\n  padding: 0.5rem 0.75rem;\n  border: 2px solid var(--border-strong);\n  border-radius: 6px;\n  font-size: 1rem;\n  width: 250px;\n}\n\n.auth-form button {\n  padding: 0.5rem 1.25rem;\n  border: none;\n  border-radius: 6px;\n  background: var(--accent);\n  color: white;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.auth-form button:hover {\n  background: var(--accent-hover);\n}\n\n.logout-btn {\n  width: 100%;\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 0.4rem 0.75rem;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.12s;\n}\n\n.logout-btn:hover {\n  border-color: #ef4444;\n  color: #ef4444;\n}\n\n/* Salary page */\n.salary-hint {\n  color: var(--text-faint);\n  margin-bottom: 1rem;\n}\n\n.salary-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-width: 480px;\n  margin-bottom: 1rem;\n}\n\n.salary-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 6px;\n  background: var(--bg-card);\n}\n\n.salary-config {\n  flex: 1;\n  font-weight: 500;\n}\n\n.salary-row input {\n  width: 200px;\n  padding: 0.4rem 0.6rem;\n  border: 1px solid var(--border-strong);\n  border-radius: 4px;\n  background: var(--bg);\n  color: var(--text);\n  font-family: inherit;\n}\n\n.salary-totals {\n  display: flex;\n  gap: 2rem;\n  max-width: 480px;\n  margin: 0.5rem 0 1rem;\n  padding: 0.75rem;\n  border-top: 1px solid var(--border-strong);\n  font-weight: 500;\n}\n\n.salary-totals-label {\n  color: var(--text-faint);\n  font-weight: 400;\n  margin-right: 0.4rem;\n}\n\n.salary-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.salary-actions button {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 6px;\n  background: var(--accent);\n  color: white;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.salary-actions button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.salary-status {\n  color: var(--text-faint);\n}\n\n/* ==========================================================================\n   Upload page (v1). Own `up-` classes: the older .cluster-* / .file-row classes are shared with\n   Groups, Home, Overall and the v2 pages, so they are left untouched here.\n   ========================================================================== */\n\n.up-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.up-header h2 {\n  margin: 0;\n}\n\n.up-toolbar {\n  display: flex;\n  gap: 0.5rem;\n  margin-left: auto;\n  flex-wrap: wrap;\n}\n\n.up-search,\n.up-select {\n  padding: 0.45rem 0.7rem;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background: var(--bg-card);\n  color: var(--text);\n  font: inherit;\n  font-size: 0.875rem;\n}\n\n.up-search {\n  min-width: 220px;\n}\n\n.up-search:focus,\n.up-select:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n/* Cluster list on the left, file panel on the right; stacked on narrow screens. */\n.up-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 400px;\n  gap: 1.25rem;\n  align-items: start;\n  margin-bottom: 2.5rem;\n}\n\n@media (max-width: 960px) {\n  .up-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* Groups stack vertically at full width. The old .cluster-list is a wrapping flex row, which laid\n   the group sections side by side and made neighbours jump when one was expanded. */\n.up-browser {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.up-section {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--bg-card);\n  overflow: hidden;\n}\n\n.up-section-head {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.6rem 0.8rem;\n  border: 0;\n  background: var(--bg-subtle);\n  color: var(--text);\n  font: inherit;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n}\n\n.up-section-head:hover {\n  background: var(--bg-hover);\n}\n\n.up-section-arrow {\n  width: 1em;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.up-section-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.up-section-count {\n  margin-left: auto;\n  font-size: 0.75rem;\n  color: var(--text-faint);\n}\n\n.up-section-body {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  padding: 0.6rem;\n  border-top: 1px solid var(--border);\n}\n\n.up-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  max-width: 100%;\n  padding: 0.3rem 0.45rem 0.3rem 0.5rem;\n  border: 1.5px solid var(--border-strong);\n  border-radius: 999px;\n  background: var(--bg-card);\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s;\n}\n\n.up-chip:hover {\n  border-color: var(--accent);\n}\n\n.up-chip:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 1px;\n}\n\n.up-chip.is-active {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.up-chip-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.up-chip-default,\n.up-chip-delete {\n  padding: 0 0.1rem;\n  border: 0;\n  background: none;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-faint);\n}\n\n.up-chip-default {\n  font-size: 0.95rem;\n}\n\n.up-chip-default.is-on {\n  color: #e0a800;\n}\n\n/* Delete only shows on hover/focus, so a stray click on a chip cannot land on it. */\n.up-chip-delete {\n  font-size: 1.1rem;\n  opacity: 0;\n  transition: opacity 0.12s;\n}\n\n.up-chip:hover .up-chip-delete,\n.up-chip:focus-within .up-chip-delete {\n  opacity: 1;\n}\n\n.up-chip-delete:hover {\n  color: #ef4444;\n}\n\n@media (hover: none) {\n  .up-chip-delete {\n    opacity: 1;\n  }\n}\n\n.up-badge {\n  padding: 1px 6px;\n  border-radius: 10px;\n  background: var(--text-faint);\n  color: #fff;\n  font-size: 0.68rem;\n  white-space: nowrap;\n}\n\n.up-add {\n  padding: 0.55rem 1rem;\n  border: 1.5px dashed var(--border-strong);\n  border-radius: var(--radius-sm);\n  background: none;\n  color: var(--text-muted);\n  font: inherit;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.up-add:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.up-new {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.up-new .up-search {\n  flex: 1;\n}\n\n.up-empty {\n  padding: 1.25rem;\n  border: 1px dashed var(--border);\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  text-align: center;\n}\n\n/* File panel: stays in view while a long cluster list scrolls (.App-main is the scroll box). */\n.up-panel {\n  position: sticky;\n  top: 1rem;\n  padding: 1rem 1.1rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n  box-shadow: var(--shadow-sm);\n  scroll-margin-top: 1rem;\n}\n\n@media (max-width: 960px) {\n  .up-panel {\n    position: static;\n  }\n}\n\n.up-panel-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.up-panel-heading {\n  min-width: 0;\n}\n\n.up-panel-eyebrow {\n  color: var(--text-faint);\n  font-size: 0.7rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.up-panel-title {\n  margin: 0.1rem 0 0;\n  font-size: 1.1rem;\n  overflow-wrap: anywhere;\n}\n\n.up-ready {\n  padding: 2px 9px;\n  border-radius: 10px;\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.up-ready.is-ready {\n  background: rgba(22, 163, 74, 0.15);\n  color: #16a34a;\n}\n\n.up-panel-empty {\n  padding: 2rem 0.5rem;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.up-file {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.55rem 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.up-file-meta {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.up-file-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.up-file-name {\n  overflow: hidden;\n  color: var(--text-faint);\n  font-size: 0.78rem;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.up-file.is-present .up-file-name {\n  color: #16a34a;\n}\n\n.up-file.is-pending .up-file-name {\n  color: var(--accent);\n}\n\n.up-file .file-replace {\n  flex-shrink: 0;\n}\n\n.up-optional-toggle {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n  width: 100%;\n  padding: 0.8rem 0 0.3rem;\n  border: 0;\n  background: none;\n  color: var(--text-muted);\n  font: inherit;\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.up-optional-count {\n  margin-left: auto;\n  color: var(--text-faint);\n  font-size: 0.75rem;\n}\n\n.up-panel .actions {\n  margin-bottom: 0.5rem;\n}\n\n/* Settings that are not about a cluster, kept out of the file workflow. */\n.up-settings h2 {\n  margin: 0 0 0.75rem;\n}\n\n.up-settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.up-card {\n  min-width: 0;\n  padding: 1rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--bg-card);\n}\n\n.up-card h4 {\n  margin: 0 0 0.2rem;\n}\n\n.up-card-hint {\n  margin: 0 0 0.75rem;\n  color: var(--text-faint);\n  font-size: 0.78rem;\n}\n\n.up-config-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.up-config {\n  padding: 0.3rem 0.75rem;\n  border: 1.5px solid var(--border-strong);\n  border-radius: 999px;\n  background: var(--bg-card);\n  color: var(--text);\n  font: inherit;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.up-config:hover {\n  border-color: var(--accent);\n}\n\n.up-config.is-on {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.up-inline {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.up-inline input[type=\"file\"] {\n  max-width: 100%;\n}\n\n.up-ellipsis {\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.up-rate {\n  width: 130px;\n  min-width: 0;\n}\n\n.up-primary {\n  padding: 0.25rem 0.8rem;\n  border: none;\n  border-radius: 4px;\n  background: var(--accent);\n  color: white;\n  cursor: pointer;\n}\n\n.up-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Salary page: the multiplier comes from the shared period setting, so say where it is from. */\n.salary-months-hint {\n  display: block;\n  margin-top: 0.15rem;\n  color: var(--text-faint);\n  font-size: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
